module.exports = [
  // types
  require('./Matrix'),
  require('./DenseMatrix'),
  require('./SparseMatrix'),
  require('./Spa'),
  require('./FibonacciHeap'),
  require('./ImmutableDenseMatrix'),
  require('./MatrixIndex'),
  require('./Range'),

  // construction functions
  require('./function/index'),
  require('./function/matrix'),
  require('./function/sparse')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/matrix/index.js
// module id = 1265
// module chunks = 0